import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";

export function openMail(email: string) {
  let dominio = email.split("@")[1];
  window.open("http://" + dominio, '_blank');
}

export function resendMail(email: string, openToast: Function,t:any) {
  let body = { email };
  postAxios(apiNames.IDENTITY, false, "/customers/resend-verification-email", body)
    .then((response) => {
      openToast("success", t('literal.registroPage.toast.success.title'), t('literal.registroPage.toast.success.desc')+ email ? email : t('literal.registroPage.toast.success.yourEmail'))
    }).catch((error) => {
      if (error?.status == 409) {
        openToast("error", t('literal.registroPage.toast.errorExists.title'), t('literal.registroPage.toast.errorExists.desc'));
      } else if (Math.floor(error?.status / 100) === 4) {
        openToast("error", t('literal.registroPage.toast.errorTryLater.title'), t('literal.registroPage.toast.errorTryLater.desc'));
      }
    })
}